// import React from "react";
// import { Swiper, SwiperSlide } from "swiper/react";
// import { Autoplay, Navigation, Pagination } from "swiper/modules";
// import "swiper/css";
// import "swiper/css/navigation";
// import "swiper/css/pagination";

// const Testimonialsabout = () => {
// const data = [
//   {
//     img: "testi_1_1.jpg",
//     title: "Comfortable Urbania Journey",
//     text:
//       "We booked a 14 seater Urbania on rent in Pune for our family trip. The vehicle was very comfortable, clean, and the ride quality was excellent.",
//     name: "Mr. Rahul Sharma",
//     role: "Software Engineer",
//   },
//   {
//     img: "testi_1_2.jpg",
//     title: "Best Service in Pune",
//     text:
//       "Urbania rental service in Pune was amazing. On-time pickup, polite driver, and smooth travel experience for our corporate outing.",
//     name: "Miss Neha Patil",
//     role: "Doctor",
//   },
//   {
//     img: "testi_1_3.jpg",
//     title: "Luxury Group Travel",
//     text:
//       "Urbania is perfect for group travel. Spacious seating, AC worked perfectly, and the journey from Pune to Mahabaleshwar was very relaxing.",
//     name: "Mr. Ankit Deshmukh",
//     role: "Business Owner",
//   },
//   {
//     img: "testi_1_1.jpg",
//     title: "Safe & Reliable Ride",
//     text:
//       "We hired Urbania on rent in Pune for a wedding function. The vehicle arrived on time and gave a premium experience to our guests.",
//     name: "Miss Pooja Kulkarni",
//     role: "Teacher",
//   },
//   {
//     img: "testi_1_2.jpg",
//     title: "Corporate Travel Made Easy",
//     text:
//       "For office travel and events, Urbania rental in Pune is the best option. Very professional service and smooth booking process.",
//     name: "Mr. Sandeep Joshi",
//     role: "HR Manager",
//   },
//   {
//     img: "testi_1_3.jpg",
//     title: "Highly Recommended Urbania",
//     text:
//       "Booked Urbania on rent in Pune for outstation travel. Excellent mileage, luxury interiors, and stress-free journey.",
//     name: "Miss Ritu Malhotra",
//     role: "Event Planner",
//   },
// ];

//   return (
//     <section className="testi-card-area-1 space overflow-hidden" id="testi-sec">
//       {/* Background Shape */}
//       <div className="shape-mockup" style={{ right: 0, top: 0 }}>
//         <img src="/img/shape/testi-irhgt-shpae-bg.png" alt="shape-bg" />
//       </div>

//       <div className="container">
//         {/* Section Title */}
//         <div className="row justify-content-center">
//           <div className="col-xxl-7 col-xl-7">
//             <div className="title-area text-center">
//               <h2 className="sec-title">Customer Reviews – Urbania on Rent in Pune</h2>
//               <p>
//                 Real experiences from customers who booked Urbania rental
//                 services in Pune for tours, weddings, and corporate travel.
//               </p>
//             </div>
//           </div>
//         </div>

//         {/* Testimonials Slider */}
//         <Swiper
//           modules={[Autoplay, Navigation, Pagination]}
//           autoplay={{ delay: 3500, disableOnInteraction: false }}
//           loop
//           navigation
//           pagination={{ clickable: true }}
//           spaceBetween={30}
//           breakpoints={{
//             0: { slidesPerView: 1 },
//             992: { slidesPerView: 2 },
//             1200: { slidesPerView: 3 },
//           }}
//         >
//           {data.map((item, index) => (
//             <SwiperSlide key={index}>
//               <div className="testi-block bg-smoke">
//                 <div className="testi-block-top">
                

//                   <div className="content">
//                     <div className="box-review">
//                       {[...Array(5)].map((_, i) => (
//                         <i key={i} className="fa-sharp fa-solid fa-star"></i>
//                       ))}
//                       <div className="rating">
//                         <span>5.0 / 5.0 Reviews</span>
//                       </div>
//                     </div>

//                     <h3 className="box-title">{item.title}</h3>
//                     <p className="box-text">“{item.text}”</p>

//                     <div className="content-bottom">
//                       <div className="left">
//                         <h3 className="name-title">{item.name}</h3>
//                         <p className="box-desig">Urbania Customer</p>
//                       </div>
//                       <div className="right">
//                         <img
//                           src="/img/icon/testi-quote-icon.png"
//                           alt="quote"
//                         />
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </SwiperSlide>
//           ))}
//         </Swiper>
//       </div>
//     </section>
//   );
// };

// export default Testimonialsabout;



import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";

const testimonials = [
  {
    img: "testi_1_1.jpg",
    title: "Comfortable Urbania Journey",
    text:
      "We booked a 14 seater Urbania on rent in Pune for our family trip. The vehicle was very comfortable, clean, and the ride quality was excellent throughout the journey.",
    name: "Mr. Rahul Sharma",
    role: "Software Engineer",
  },
  {
    img: "testi_1_2.jpg",
    title: "Best Service in Pune",
    text:
      "Urbania rental service in Pune was amazing. On-time pickup, polite driver, and smooth travel experience made our corporate outing very enjoyable.",
    name: "Miss Neha Patil",
    role: "Doctor",
  },
  {
    img: "testi_1_3.jpg",
    title: "Luxury Group Travel",
    text:
      "Urbania is perfect for group travel. Spacious seating, fully working AC, and the journey from Pune to Mahabaleshwar was relaxing and stress-free.",
    name: "Mr. Ankit Deshmukh",
    role: "Business Owner",
  },
  {
    img: "testi_1_1.jpg",
    title: "Safe & Reliable Ride",
    text:
      "We hired Urbania on rent in Pune for a wedding function. The vehicle arrived on time and offered a premium, comfortable experience to our guests.",
    name: "Miss Pooja Kulkarni",
    role: "Teacher",
  },
  {
    img: "testi_1_2.jpg",
    title: "Corporate Travel Made Easy",
    text:
      "For office travel and events, Urbania rental in Pune is the best option. Very professional service and smooth booking process ensured a hassle-free trip.",
    name: "Mr. Sandeep Joshi",
    role: "HR Manager",
  },
  {
    img: "testi_1_3.jpg",
    title: "Highly Recommended Urbania",
    text:
      "Booked Urbania on rent in Pune for outstation travel. Excellent mileage, luxurious interiors, and a completely stress-free journey made it highly recommended.",
    name: "Miss Ritu Malhotra",
    role: "Event Planner",
  },
];

const Testimonialsabout = () => {
  return (
    <section
      className="testi-card-area-1 py-4 bg-smoke overflow-hidden"
      id="testi-sec"
    >
      {/* Shape */}
      <div className="shape-mockup" style={{ right: 0, top: 0 }}>
        <img
          src="/img/shape/testi-irhgt-shpae-bg.png"
          alt="shape-bg"
        />
      </div>

      <div className="container">
        {/* Title */}
        <div className="row justify-content-center">
          <div className="col-xxl-7 col-xl-7">
            <div className="title-area text-center section-header">
              <h2 className="sec-title ">Our Customer Feedback!</h2>
              <p>
                Many dealerships have service departments equipped with certified
                technicians who handle maintenance, repairs, oil changes, tire
                rotations, and other essential vehicle services.
              </p>
            </div>
          </div>
        </div>

        {/* Slider */}
        <div className="row justify-content-center">
          <div className="testi-card-slide position-relative">
            <Swiper
              modules={[Navigation, Pagination, Autoplay]}
              loop
              autoplay={{ delay: 3500, disableOnInteraction: false }}
              navigation={{
                nextEl: ".slider-next",
                prevEl: ".slider-prev",
              }}
              pagination={{
                el: ".slider-pagination",
                clickable: true,
              }}
              breakpoints={{
                0: { slidesPerView: 1 },
                768: { slidesPerView: 1 },
                992: { slidesPerView: 2 },
                1200: { slidesPerView: 3 },
              }}
              className="has-shadow"
            >
              {testimonials.map((item, index) => (
                <SwiperSlide key={index}>
                  <div className="testi-block" dir="ltr">
                    <div className="testi-block-top">
                      {/* <div className="box-img">
                        <img
                          src={`/img/testimonial/${item.img}`}
                          alt="avatar"
                        />
                      </div> */}

                      <div className="content">
                        <div className="box-review">
                          {[...Array(5)].map((_, i) => (
                            <i
                              key={i}
                              className="fa-sharp fa-solid fa-star"
                            ></i>
                          ))}
                          <div className="rating">
                            <span>4.0 / 5.0 Reviews</span>
                          </div>
                        </div>

                        <h3 className="box-title">{item.title}</h3>
                        <p className="box-text">“{item.text}”</p>

                        <div className="content-bottom">
                          <div className="left">
                            <h3 className="name-title">{item.name}</h3>
                           <p className="box-desig">{item.role}</p>
                          </div>
                          <div className="right">
                            <img
                              src="/img/icon/testi-quote-icon.png"
                              alt="quote"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>

            {/* Pagination & Arrows */}
            <div className="pagination-count-wrap border-style">
              <div className="pagination-wrap">
                <div className="slider-pagination"></div>
              </div>
            </div>

            {/* <button className="slider-arrow slider-prev">
              <i className="far fa-arrow-left"></i>
            </button>
            <button className="slider-arrow slider-next">
              <i className="far fa-arrow-right"></i>
            </button> */}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonialsabout;